import { Intent } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { ID, VKVideoItem } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import VKVideoButton, { InlineButton, VKVideoPlayer } from "."
import "./index.scss"
import PlayList, { PlayListContainer } from "./PlayList"
import { VIDEO_PAYER_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import PlayListCarousel from "./PlayListCarousel"
import PlayListTile from "./PlayListTile"

/* Protopia Ecosystem component */
export interface IvkVideoPlayListProps {
    id: ID
    items: VKVideoItem[]
    btnWidth?:  number
    btnHeight?: number
    padding?:   number 
    intent?:    Intent | string
    minimal?:   boolean
    fill?:      boolean
    image?:     URL | string
    label:      string
    isModal?:   boolean
    isAutoMode?: boolean
    descriptionAfter?: boolean
    isPlayButton?: boolean
    onEnded?: () => void
    playerDesign?: VIDEO_PAYER_DESIGN_TYPE
    containerWidth?: number
    columnsCount?: number
}
const VkVideoPlayList = ({items, columnsCount, ...props}: IvkVideoPlayListProps): JSX.Element => {
    const [current, setCurrent] = useState<VKVideoItem>( items[0] || {})
    const [isPlayed, setIsPlayed] = useState<boolean>( false )
    const [isPlayerOpen, setIsPlayerOpen] = useState<boolean>( false ) 
    let timeout = 0
    useEffect(() => { 
         
        return () => clearTimeout(timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const play = () => {
        setTimeout(() => {
            setIsPlayed(true)
            console.log( "playlist: play" )
        }, 100)
    }
    const onEnded = () => {
        const currentI = items.findIndex( () => current )
        if(currentI < items.length - 1) {
            setCurrent( items[currentI + 1] )
            setIsPlayerOpen(false)
            play()
        } 
    }
    const onSwitch = (i: number) => {
        setCurrent( items[i] )
        setIsPlayerOpen(false)
        play()
    }
    const onSwitchCarousel = (i: number) => {
        setCurrent( items[i] )
        setIsPlayerOpen(false)
        VKVideoPlayer.stopAll()
    }
    const getPlayerWidth = () => {
        return props.playerDesign === VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST || 
            props.playerDesign === VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS
            ?
            ( props.btnWidth || 640 )
            :
            ( props.btnWidth || 640 ) * .66 
            
    }
    switch(props.playerDesign)  {
        case VIDEO_PAYER_DESIGN_TYPE.TILE:
            return <PlayListTile {...props} 
                items={items} 
                current={current} 
                onSwitch={ onSwitch }  
                containerWidth={ props.containerWidth || 1300 }  
                columnsCount={columnsCount} 
            />
        case VIDEO_PAYER_DESIGN_TYPE.CAROUSEL:
            return <PlayListCarousel {...props} items={items} containerWidth={props.btnWidth || 640}  current={current} onSwitch={ onSwitchCarousel } />
        default:
            return <PlayListContainer {...props} items={items} containerWidth={props.btnWidth || 640}  current={current} > 
                <VKVideoButton 
                    src={current?.src}
                    label={current.label || __("Empty playlist")}
                    description={current.content }
                    image={current?.image || props.image?.toString() || ""}
                    padding={ props.padding }
                    intent={ props.intent }
                    minimal={ props.minimal } 
                    btnWidth={getPlayerWidth()}
                    btnHeight={ props.btnHeight }
                    fill={ props.fill }
                    isModal={ props.isModal } 
                    isAutoMode={ false }
                    isPlayButton={ typeof props.isPlayButton === "undefined" ? true : props.isPlayButton  && !!items.length }
                    isPlayed={ isPlayed }
                    onEnded={ onEnded }
                    isPlayerOpen={ isPlayerOpen }
                    descriptionAfter={ props.descriptionAfter && props.playerDesign === VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST }
                />
                <PlayList 
                    {...props} 
                    items={items} 
                    current={current} 
                    onSwitch={ onSwitch } 
                    containerWidth={props.btnWidth || 640} 
                />
                
            </PlayListContainer>
    }
    
}
export default VkVideoPlayList

